export enum EKnowledgeBase {
  getData = 'knowledgeBase/getData',
  completeData = 'knowledgeBase/complete',
  finishReadingData = 'knowledgeBase/finishReading',
  getKnowledgeStat = 'knowledgeBase/stat',
}
